import { FieldBlock } from '@coast/schemas';
import { isNil } from 'lodash';
import { useWorkflowTemplate } from '@shared/scenes/workflows/hooks';
import { MBFieldBlock } from '../field';

interface Props {
  block: FieldBlock;
  value: { workflowTemplateId?: string; name?: string } | null;
}

export function SubformsFieldBlock({ block, value }: Props) {
  const subformWorkflowTemplateId = isNil(value) ? undefined : value.workflowTemplateId;
  const { workflowTemplate } = useWorkflowTemplate(subformWorkflowTemplateId);

  if (isNil(value)) {
    return null;
  }

  const displayValue = workflowTemplate?.name ?? value.name ?? '';
  return <MBFieldBlock value={displayValue} block={block} />;
}
